import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminSupplementInquiryStatuses;
export const adminSupplementInquiryStatusesSelector = (state: RootState) => getState(state).data;
export const adminSupplementInquiryStatusesIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminSupplementInquiryStatusesIsReadySelector = (state: RootState) =>
  getState(state).isReady;
export const adminSupplementInquiryStatusesErrorSelector = (state: RootState) =>
  getState(state).error;
